import { getScenarioStore } from 'owa-search-store';

/**
 * Returns the active descendant ID for the search input, for use with aria-activedescendant.
 *
 * @param scenarioId - The search scenario ID
 */
import type { SearchScenarioId } from 'owa-search-store';

export function getSelectedQuickActionId(scenarioId: SearchScenarioId): string {
    const {
        selectedSuggestionIndex,
        suggestionsQuickActions,
        currentSuggestions,
        selectedSuggestionQuickActionSelected,
        selectedSuggestionActiveQuickActionIndex,
    } = getScenarioStore(scenarioId);

    if (selectedSuggestionQuickActionSelected && selectedSuggestionActiveQuickActionIndex >= 0) {
        const quickActions = suggestionsQuickActions.get(selectedSuggestionIndex);
        const selectedSuggestion = currentSuggestions?.Suggestions[selectedSuggestionIndex];
        const activeQuickActionId = quickActions?.find(
            (_value, index) => index === selectedSuggestionActiveQuickActionIndex
        );
        if (
            currentSuggestions &&
            selectedSuggestion &&
            quickActions &&
            activeQuickActionId !== undefined
        ) {
            return `${activeQuickActionId}`;
        }
    }
    return '';
}
